import React, { useState } from 'react';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { 
  Users, 
  Building2, 
  ArrowLeft,
  Sparkles,
  Eye
} from 'lucide-react';
import { agentAdvancerSenzaSfondo } from '../images';
import DemoAgenzia from './DemoAgenzia';
import DemoCandidato from './DemoCandidato';

const DemoMain = () => {
  const [activeView, setActiveView] = useState('selector'); // 'selector', 'agenzia', 'candidato'
  const [showBanner, setShowBanner] = useState(true);

  const handleBackToHome = () => {
    window.location.href = '/';
  };

  const handleViewSelect = (view) => {
    setActiveView(view);
  };

  const handleBackToSelector = () => {
    setActiveView('selector');
  };

  if (activeView === 'agenzia') {
    return (
      <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-slate-100">
        {/* Demo Banner */}
        {showBanner && (
          <div className="bg-gradient-to-r from-blue-600 via-blue-700 to-amber-600 text-white px-4 py-3 shadow-lg">
            <div className="max-w-7xl mx-auto flex items-center justify-between">
              <div className="flex items-center gap-2">
                <Sparkles className="w-5 h-5" />
                <span className="font-semibold">🔹 Modalità Demo</span>
                <span className="hidden sm:inline">• Dati simulati per scopi dimostrativi</span>
              </div>
              <div className="flex items-center gap-3">
                <Button
                  onClick={handleBackToSelector}
                  variant="outline"
                  size="sm"
                  className="bg-white/20 border-white/30 text-white hover:bg-white/30"
                >
                  <ArrowLeft className="w-4 h-4 mr-1" />
                  Cambia Vista
                </Button>
                <Button
                  onClick={() => setShowBanner(false)}
                  variant="ghost"
                  size="sm"
                  className="text-white hover:bg-white/20"
                >
                  ✕
                </Button>
              </div>
            </div>
          </div>
        )}
        
        {/* Watermark */}
        <div className="fixed top-20 right-4 z-10 bg-blue-600/10 text-blue-600 px-3 py-1 rounded-full text-sm font-semibold backdrop-blur">
          DEMO
        </div>

        <DemoAgenzia />
      </div>
    );
  }

  if (activeView === 'candidato') {
    return (
      <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-slate-100">
        {/* Demo Banner */}
        {showBanner && (
          <div className="bg-gradient-to-r from-blue-600 via-blue-700 to-amber-600 text-white px-4 py-3 shadow-lg">
            <div className="max-w-7xl mx-auto flex items-center justify-between">
              <div className="flex items-center gap-2">
                <Sparkles className="w-5 h-5" />
                <span className="font-semibold">🔹 Modalità Demo</span>
                <span className="hidden sm:inline">• Dati simulati per scopi dimostrativi</span>
              </div>
              <div className="flex items-center gap-3">
                <Button
                  onClick={handleBackToSelector}
                  variant="outline"
                  size="sm"
                  className="bg-white/20 border-white/30 text-white hover:bg-white/30"
                >
                  <ArrowLeft className="w-4 h-4 mr-1" />
                  Cambia Vista
                </Button>
                <Button
                  onClick={() => setShowBanner(false)}
                  variant="ghost"
                  size="sm"
                  className="text-white hover:bg-white/20"
                >
                  ✕
                </Button>
              </div>
            </div>
          </div>
        )}

        {/* Watermark */}
        <div className="fixed top-20 right-4 z-10 bg-blue-600/10 text-blue-600 px-3 py-1 rounded-full text-sm font-semibold backdrop-blur">
          DEMO
        </div>

        <DemoCandidato />
      </div>
    );
  }

  // Selector View
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-900 via-slate-900 to-blue-800 flex items-center justify-center p-4">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-30">
        <div className="w-full h-full bg-gradient-to-r from-blue-900/5 to-purple-900/5"></div>
      </div>
      
      <div className="relative max-w-4xl mx-auto text-center">
        {/* Header */}
        <div className="mb-8">
          <div className="flex items-center justify-center gap-3 mb-6">
            <div className="w-16 h-16 bg-white rounded-2xl flex items-center justify-center shadow-xl p-2">
              <img 
                src={agentAdvancerSenzaSfondo} 
                alt="InLeads Logo" 
                className="w-full h-full object-contain"
              />
            </div>
            <h1 className="text-4xl font-bold bg-gradient-to-r from-blue-400 to-amber-400 bg-clip-text text-transparent">
              Demo InLeads
            </h1>
          </div>
          
          <p className="text-xl text-blue-100 mb-2">
            Scopri come funziona la piattaforma che collega agenzie e candidati
          </p>
          <p className="text-blue-300">
            Scegli la vista che vuoi esplorare • Durata: ~90 secondi
          </p>
        </div>

        {/* View Selection Cards */}
        <div className="grid md:grid-cols-2 gap-6 mb-8">
          {/* Agenzia Demo */}
          <Card 
            className="bg-white/10 backdrop-blur-lg border-white/20 hover:bg-white/15 transition-all duration-300 cursor-pointer group"
            onClick={() => handleViewSelect('agenzia')}
          >
            <CardContent className="p-8 text-center">
              <div className="w-16 h-16 bg-gradient-to-r from-blue-500 to-blue-600 rounded-2xl flex items-center justify-center mx-auto mb-4 group-hover:scale-110 transition-transform">
                <Building2 className="w-8 h-8 text-white" />
              </div>
              
              <h3 className="text-2xl font-bold text-white mb-3">
                Vista Agenzia
              </h3>
              
              <p className="text-blue-200 mb-6 leading-relaxed">
                Gestisci candidati qualificati, programma colloqui in un clic, 
                e comunica i tuoi successi alla zona di riferimento.
              </p>
              
              <div className="space-y-2 text-left">
                <div className="flex items-center text-blue-300 text-sm">
                  <span className="w-2 h-2 bg-blue-400 rounded-full mr-2"></span>
                  25 candidati attivi da gestire
                </div>
                <div className="flex items-center text-blue-300 text-sm">
                  <span className="w-2 h-2 bg-blue-400 rounded-full mr-2"></span>
                  Strumenti per chiamate e colloqui
                </div>
                <div className="flex items-center text-blue-300 text-sm">
                  <span className="w-2 h-2 bg-blue-400 rounded-full mr-2"></span>
                  Sistema di note interne
                </div>
                <div className="flex items-center text-blue-300 text-sm">
                  <span className="w-2 h-2 bg-blue-400 rounded-full mr-2"></span>
                  Feed per comunicare con i candidati
                </div>
              </div>
              
              <Button className="w-full mt-6 bg-gradient-to-r from-blue-500 to-blue-600 hover:from-blue-600 hover:to-blue-700 text-white rounded-2xl py-3 group-hover:shadow-lg transition-all">
                <Eye className="w-4 h-4 mr-2" />
                Esplora Vista Agenzia
              </Button>
            </CardContent>
          </Card>

          {/* Candidato Demo */}
          <Card 
            className="bg-white/10 backdrop-blur-lg border-white/20 hover:bg-white/15 transition-all duration-300 cursor-pointer group"
            onClick={() => handleViewSelect('candidato')}
          >
            <CardContent className="p-8 text-center">
              <div className="w-16 h-16 bg-gradient-to-r from-amber-500 to-orange-500 rounded-2xl flex items-center justify-center mx-auto mb-4 group-hover:scale-110 transition-transform">
                <Users className="w-8 h-8 text-white" />
              </div>
              
              <h3 className="text-2xl font-bold text-white mb-3">
                Vista Candidato
              </h3>
              
              <p className="text-blue-200 mb-6 leading-relaxed">
                Visualizza le opportunità delle agenzie della tua zona, 
                lascia feedback e rimani aggiornato sui loro successi.
              </p>
              
              <div className="space-y-2 text-left">
                <div className="flex items-center text-blue-300 text-sm">
                  <span className="w-2 h-2 bg-amber-400 rounded-full mr-2"></span>
                  5 opportunità da agenzie selezionate
                </div>
                <div className="flex items-center text-blue-300 text-sm">
                  <span className="w-2 h-2 bg-amber-400 rounded-full mr-2"></span>
                  Sistema di feedback post-chiamata
                </div>
                <div className="flex items-center text-blue-300 text-sm">
                  <span className="w-2 h-2 bg-amber-400 rounded-full mr-2"></span>
                  Feed geolocalizzato per la tua zona
                </div>
                <div className="flex items-center text-blue-300 text-sm">
                  <span className="w-2 h-2 bg-amber-400 rounded-full mr-2"></span>
                  Dashboard con statistiche personali
                </div>
              </div>
              
              <Button className="w-full mt-6 bg-gradient-to-r from-amber-500 to-orange-500 hover:from-amber-600 hover:to-orange-600 text-white rounded-2xl py-3 group-hover:shadow-lg transition-all">
                <Eye className="w-4 h-4 mr-2" />
                Esplora Vista Candidato
              </Button>
            </CardContent>
          </Card>
        </div>

        {/* Back Button */}
        <Button
          onClick={handleBackToHome}
          variant="outline"
          className="bg-white/10 border-white/20 text-white hover:bg-white/20 rounded-2xl px-8 py-3"
        >
          <ArrowLeft className="w-4 h-4 mr-2" />
          Torna alla Home
        </Button>
      </div>
    </div>
  );
};

export default DemoMain;